module.exports = __webpack_public_path__ + "static/media/rank-no-2.6c7e6c9d.svg";